// src/components/job-engine/JobTimeline.tsx
import React from "react";
import { Stack, Text } from "@fluentui/react";
import { formatDateTime } from "./formatters";
import StatePill from "./StatePill";
import type { JobEvent } from "@/api/jobEngine";

interface Props { events: JobEvent[]; }

const JobTimeline: React.FC<Props> = ({ events }) => (
  <Stack tokens={{ childrenGap: 10 }}>
    {events.length === 0 && <Text variant="small">No events yet.</Text>}
    {events.map((e) => (
      <Stack key={e.eventId} horizontal tokens={{ childrenGap: 8 }} verticalAlign="start">
        <StatePill state={e.state} />
        <Stack>
          <Text variant="small">{formatDateTime(e.occurredAt)}</Text>
          {e.detail && <Text variant="small" styles={{ root: { color: "#605e5c" } }}>{e.detail}</Text>}
        </Stack>
      </Stack>
    ))}
  </Stack>
);

export default JobTimeline;
